import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

/**
 * Cache chung cho các API đọc-only của doanh nghiệp:
 * - GET /enterprises/configs/{enterpriseId} — config doanh nghiệp (enableManageBranch, maxSizeSystem, ...)
 * - GET /enterprises/resources/{enterpriseId} — tài nguyên dịch vụ đang dùng (ẩn/hiện menu header)
 * Dữ liệu ít thay đổi trong phiên, dùng chung 1 request cho nhiều caller.
 */
@Injectable({
  providedIn: 'root'
})
export class EnterpriseConfigService {

  private cached$: Observable<any>;
  private cachedEnterpriseId: string;
  private cachedResources$: Observable<any>;
  private cachedResourcesEnterpriseId: string;
  private invalidated = new Subject<void>();

  constructor(
    private apiService: ApiService
  ) {
  }

  getConfig(enterpriseId: string): Observable<any> {
    if (!this.cached$ || this.cachedEnterpriseId !== enterpriseId) {
      this.cachedEnterpriseId = enterpriseId;
      this.cached$ = this.apiService.get(`/enterprises/configs/${enterpriseId}`).pipe(
        shareReplay(1)
      );
    }
    return this.cached$;
  }

  getResources(enterpriseId: string): Observable<any> {
    if (!this.cachedResources$ || this.cachedResourcesEnterpriseId !== enterpriseId) {
      this.cachedResourcesEnterpriseId = enterpriseId;
      this.cachedResources$ = this.apiService.get(`/enterprises/resources/${enterpriseId}`).pipe(
        shareReplay(1)
      );
    }
    return this.cachedResources$;
  }

  // gọi sau khi update config/thay đổi tài nguyên thành công để các lần đọc sau fetch lại
  invalidate() {
    this.cached$ = null;
    this.cachedEnterpriseId = null;
    this.cachedResources$ = null;
    this.cachedResourcesEnterpriseId = null;
    this.invalidated.next();
  }

  onChanged() {
    return this.invalidated.asObservable();
  }
}
